// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_fw","advertDetailParameterList__header":"c-o_fx","advertDetailParameterList__list":"c-o_fy"};